import { FormEvent, useContext, useEffect, useState } from "react";
import { Button, Loader } from "../Styles";
import { ModalEstadoContext } from "../../contexts/ModalEstado";
import { toast } from "react-toastify";
import { IndicadoresLista, indicadoresTarefa, paramsIndicadoresLista } from "../../interfaces/indicadores";
import { BsFileEarmarkBarGraph } from "react-icons/bs";
import { atualizarIndicadorProjeto, cadastrarIndicadorAoProjeto, listarBancoIndicador } from "../../services/indicadores";
import { criptografarDado, descriptografarDado } from "../../helpers";
import { useLocation } from "react-router-dom";
import { listarMembrosProjeto } from "../../services/projetos";
import { membrosResponsaveis } from "../../interfaces/desafios";
import avatarDefault from '../../assets/img/avatarDefault.png'
import "./modalIndicador.css"
import { ListaIndicadorMensuracao } from "../../interfaces/indicadorMensuracao";
import ModalIndicadorMensuracao from "../ModalMensuracao";

function ModalIndicador({ indicador }: paramsIndicadoresLista) {
  const { modalSecundario, modalExibir, atualizarDados, atualizarInformacoes, modalSecundarioExibir } = useContext(ModalEstadoContext)

  const { search } = useLocation()
  const paramsUrl = new URLSearchParams(search)

  const idProjeto = paramsUrl.get("idProjeto");
  const grupo = paramsUrl.get("grupo");

  const [processando, setProcessando] = useState(false);

  const [indicadoresDisponiveis, setIndicadoresDisponiveis] = useState<indicadoresTarefa[]>([]);
  const [indicadorSelecionado, setIndicadorSelecionado] = useState("");

  const [responsaveis, setResponsaveis] = useState<membrosResponsaveis[]>([]);
  const [responsavel, setIdResponsavel] = useState("");

  const [situacao, setSituacao] = useState(indicador?.situacao);
  const [mensuracaoSelecionada, setMensuracaoSelecionada] = useState<ListaIndicadorMensuracao>();
  const [indicadorMensuracaoSelecionado, setIndicadorMensuracaoSelecionado] = useState<IndicadoresLista>();

  const handleSubmitIndicador = async (e: FormEvent) => {
    e.preventDefault()
    setProcessando(true)
    try {
      if (!indicadorSelecionado) return toast.error("Indicador não encontrado.")
      if (!idProjeto) return toast.error("Projeto não encontrado.")

      const payload = {
        idProjeto,
        idIndicador: criptografarDado(indicadorSelecionado),
        idResponsavel: responsavel,
      }

      const resposta = await cadastrarIndicadorAoProjeto(payload)

      if (resposta.status === 201) {
        setProcessando(false)
        atualizarDados()
        modalExibir("")
        return toast.success("Indicador Vinculado com Sucesso.")
      }
    } catch (error) {
      setProcessando(false)
      return toast.error("Erro ao Vincular Indicador.")
    }
  }

  const handleUpdateIndicador = async (e: FormEvent) => {
    e.preventDefault()
    setProcessando(true)
    if (!indicador) return toast.error("Indicador não encontrado.")
    const idIndicadorProjetoCript = criptografarDado(indicador.id.toString())
    if (!situacao) return toast.warn("Não foi possivel atualizar a situação do indicador vinculado ao projeto.")
    try {
      const payload = {
        situacao,
      }

      const resposta = await atualizarIndicadorProjeto(idIndicadorProjetoCript, payload)

      if (resposta.status === 200) {
        setProcessando(false)
        atualizarDados()
        modalExibir("")
        return toast.success("Indicador Atualizado com Sucesso.")
      }
    } catch (error: any) {
      if (error.response.status === 404) {
        setProcessando(false)
        modalExibir("")
        return toast.warn("Indicador não encontrado.")
      }
      return toast.error("Erro ao Atualizar Indicador")
    }
  }

  const abrirModalEditarMensuracao = (mensuracao: ListaIndicadorMensuracao, indicador: IndicadoresLista) => {
    setMensuracaoSelecionada(mensuracao);
    setIndicadorMensuracaoSelecionado(indicador);
    modalSecundarioExibir("ModalEditarMensuracao")
  }

  useEffect(() => {
    const listarMembrosResponsaveis = async () => {
      if (!idProjeto) return toast.error("Não foi possivel encontrar o projeto.")

      try {
        const idProjetoEncoded = encodeURIComponent(idProjeto)
        const resposta = await listarMembrosProjeto(idProjetoEncoded);
        if (resposta.status === 200) {
          return setResponsaveis(resposta.data)
        }

      } catch (error) {
        toast.error("Erro ao listar todos os membros do Projeto.");
      }
    };

    if (!indicador) listarMembrosResponsaveis()
  }, [idProjeto, grupo])

  useEffect(() => {
    const buscarIndicador = async () => {
      setProcessando(true)
      if (!idProjeto) return toast.error("Não foi possivel encontrar o Projeto.")
      if (!grupo) return toast.error("Não foi possivel encontrar o Grupo no qual o projeto está relacionado.")
      const idProjetoDescriptografado = descriptografarDado(idProjeto)
      try {
        const queryParams = {
          titulo: "",
          situacao: "Ativo",
          grupo
        }

        const resposta = await listarBancoIndicador(queryParams)
        const indicadoresDisponiveisFiltrados = resposta.data.filter(
          (indicador: any) =>
            !indicador.indicadoresProjetos.some(
              (projeto: any) => projeto.idProjeto.toString() === idProjetoDescriptografado
            )
        )

        setIndicadoresDisponiveis(indicadoresDisponiveisFiltrados)
        setProcessando(false)
      } catch (error) {
        setProcessando(false)
        return toast.error("Erro ao Buscar os Indicadores")
      }
    }
    if (!indicador) buscarIndicador()
  }, [atualizarInformacoes])

  return (
    <div className="fundoModal">
      <section className='containerModalCentro'>
        <span id='novoContainerTitulo'>
          <BsFileEarmarkBarGraph className='icone-mensuracao' title="Icone Indicador" />
          <p>{!indicador ? 'Novo Vinculo' : 'Visualizar Indicador'}</p>
        </span>
        <form id='formModalNovo' onSubmit={indicador ? handleUpdateIndicador : handleSubmitIndicador}>
          {!indicador && <section>
            <span>
              <label>Responsavel pela Mensuração</label>
              <select onChange={(e) => setIdResponsavel(e.target.value)} required={!indicador} defaultValue={responsavel}>
                <option value="" disabled>Selecione o Responsavel</option>
                {responsaveis && responsaveis.map((responsavel) => (
                  <option value={responsavel.usuario.id} key={responsavel.usuario.id}>{responsavel.usuario.nome}</option>
                ))}
              </select>
            </span>
          </section>
          }
          {!indicador && <section>
            <span>
              <label>Indicadores Disponiveis</label>
              <select onChange={(e) => setIndicadorSelecionado(e.target.value)} required={!indicador} defaultValue={indicadorSelecionado}>
                <option value="" disabled>Selecione o Indicador</option>
                {indicadoresDisponiveis && indicadoresDisponiveis.map((indicador) => (
                  <option value={indicador.id} key={indicador.id}>{indicador.titulo}</option>
                ))}
              </select>
            </span>
          </section>
          }
          {indicador && <section>
            <span>
              <label>situacao</label>
              <select onChange={(e) => setSituacao(e.target.value)} required={!!indicador} defaultValue={situacao}>
                <option value="Ativo">Ativo</option>
                <option value="Inativo">Inativo</option>
              </select>
            </span>
          </section>
          }
          {situacao === "Ativo" && indicador?.indicadore && indicador?.indicadore?.indicadoresMensuracaos.length > 0 && (
            <section className="container-mensuracao">
              <span>
                <label>Mensurações</label>
                <span className="span-mensuracao">
                  {indicador?.indicadore?.indicadoresMensuracaos.map((mensuracao, index) => (
                    <div
                      key={mensuracao.id || index}
                      id="inf-mensuracao"
                      className="mensuracao-clickable"
                      onClick={() => abrirModalEditarMensuracao(mensuracao, indicador)}
                    >
                      <label id="usuario-criador-mensuracao">
                        <img
                          src={mensuracao.usuario?.avatar || avatarDefault}
                          className="usuarioResponsavel"
                          alt=""
                        />
                        <p>{mensuracao.usuario.nome}</p>
                      </label>
                      <p>{`${mensuracao.competencia.slice(5, 7)}/${mensuracao.competencia.slice(0, 4)}`}</p>
                    </div>
                  ))}
                </span>
              </span>
            </section>
          )}
          <span id="botoesContainer">
            <Button type='button' cor='cancelar' isLoading={processando} onClick={() => modalExibir("")}>Fechar</Button>
            <Button type='submit' cor='salvar' isLoading={processando}>
              {!processando && !indicador && 'Cadastrar'}
              {!processando && indicador && 'Atualizar'}
              {processando && <Loader isLoading={processando} />}
            </Button>
          </span>
        </form>
      </section>
      {modalSecundario.nome === "ModalEditarMensuracao" && mensuracaoSelecionada && indicadorMensuracaoSelecionado && <ModalIndicadorMensuracao indicador={indicadorMensuracaoSelecionado} mensuracao={mensuracaoSelecionada} />}
    </div>
  );
}

export default ModalIndicador;
